<template>
    <div class="px-4 pb-4">
        <div class="flex wrapper-coupon px-2 py-2 lg:px-4">
            <img class="ml-0 mr-2.5 my-auto" src="@/assets/icon/ic-coupon-green.svg" />
            <div class="coupon ml-0 my-auto">
                <div class="campaign-name font-bold text-14 lg:text-16 text-a-brown-502314">{{getPromoCodeText()}}</div>
                
            </div>
            <div class="ml-0 my-auto text-14 lg:text-16 text-a-red-d62300" @click="clickUseCoupon()">Use Now</div>
        </div>
    </div>
</template>

<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "PromoCode",
    inject: ['PlaceOrderStore'],
    mixins: [LocaleMixin],
    props:{
        objPromoCode: Object
    },
    created: function() {

    },
    methods: {
        getPromoCodeText: function() {
            return `${this.lbl.coupon.discount} ${this.objPromoCode.pricePerUnit} ${this.lbl.coupon.bath}`;
        },
        clickUseCoupon: function() {
            this.PlaceOrderStore.state.placeOrder.coupon = {...this.objPromoCode};
            
            console.log(this.PlaceOrderStore.state.placeOrder.coupon);
            this.PlaceOrderStore.methods.updatePlaceOrder();
            
            this.$router.back();
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/text.scss";
    .wrapper-coupon {
        background-image: url('../../../assets/image/bg-coupon-mobile.svg');
        background-position: center;
        background-size: 100%;
        background-repeat: no-repeat;
        @include min-desktop {
            background-image: url('../../../assets/image/bg-coupon.svg');
        }

        .coupon {
            width: calc(100% - 115px);

            @include min-desktop {
                width: calc(100% - 122px);
            }
            .campaign-name {
                @extend %ellipsis-1;
            }
        }
    }
    
    
</style>